import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import policyActions from '../../policy/policyActions';

import { Page, PageContent, PageHeader } from '../../components/common';
import { Button } from '../../components/buttons';
import { IconAdd } from '../../components/icons';
import { TextInput } from '../../components/forms';

import * as toastr from 'toastr';

import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import Utils, { UtilsBeneficiaries, BeneficiaryTypes, SecurityRoles as roles } from '../../common/utils';

import CustomerBeneficiariesDisbursementRow from './CustomerBeneficiariesDisbursementRow';

interface Props {
	className?: string;
	beneficiaries: CustomerPolicyBeneficiaryDto[];
	customerPolicy: CustomerPolicy;
	trustee: CustomerPolicyBeneficiaryDto;
	actions: any;
	history: any;
	match: any;
}
class PolicyBeneficiariesDisbursementPage extends React.Component<Props> {
	componentDidMount() {
		const filteredBeneficiaries = this.props.beneficiaries
			.filter(b => b.customerPolicyId === this.props.customerPolicy.id);
		this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
	}

	isUpdateDisabled = () => {
		return !UtilsBeneficiaries.isDisbursementValid(this.props.beneficiaries) || this.validateTrustee();		
	}

	updateDisbursement = () => {
		const beneficiaries = this.props.beneficiaries.filter(b => b.typeId !== BeneficiaryTypes.Trustee);
		Utils.forEachPromise(beneficiaries, this.props.actions.saveCustomerPolicyBeneficiary).then(() => {
			if (this.props.beneficiaries.find(b => b.isUnderage === true)) {
				this.saveTrustee();
			}
			toastr.success('Beneficiary disbursement updated!');
			this.props.history.push(`/admin/customers/${this.props.match.params.customerId}/beneficiaries`);
		});
	}

	onTrusteeChange = (e: any) => {
		const trustee = {
			...this.props.trustee,
			[e.target.name]: e.target.value
		};
		this.props.actions.setTrustee(trustee);
	}

	saveTrustee = () => {
		let trustee = {...this.props.trustee};
		trustee.customerId = this.props.match.params.customerId;
		trustee.customerPolicyId = this.props.customerPolicy.id;
		this.props.actions.saveCustomerPolicyBeneficiary(trustee);
	}

	// true means update button should be disabled
	validateTrustee = () => {
		let result = false;
		if (!this.props.beneficiaries.some(b => b.isUnderage === true)) {
			return result;
		} else {
			if (!this.props.trustee.firstName ||
				!this.props.trustee.lastName ||
				!this.props.trustee.email ||                                 
				this.props.trustee.firstName.trim() === '' ||
				this.props.trustee.lastName.trim() === '' ||
				this.props.trustee.email.trim() === '') {
				result = true;
			}
		}
		return result;
	}

	cancelManagement = () => {
		this.props.history.push(`/admin/customers/${this.props.match.params.customerId}/beneficiaries`);
	}

	render() {
		const primaryBeneficiaries = this.props.beneficiaries.filter(b => b.typeId === BeneficiaryTypes.Primary);
		const contingentBeneficiaries = this.props.beneficiaries.filter(b => b.typeId === BeneficiaryTypes.Contingent);
		const {
			customerPolicy,
			beneficiaries,
			history,
			match,
			actions
		} = this.props;

		return (
			<Page>
				<PageContent>
					<PageHeader title="Adjust your beneficiary disbursement" />	
						<div className="customer-dashboard-plan-info">
							<strong className="d-inline large">
								Policy {this.props.customerPolicy.number}
							</strong>
						</div>
							{primaryBeneficiaries.length > 0 && 
							(
								<CustomerBeneficiariesDisbursementRow
									customerPolicy={customerPolicy}
									beneficiaries={beneficiaries}
									typedBeneficiaries={primaryBeneficiaries}
									history={history}
									match={match}
									actions={actions}
								/>
							)}
							{contingentBeneficiaries.length > 0 && 
							(
								<CustomerBeneficiariesDisbursementRow
									customerPolicy={customerPolicy}
									beneficiaries={beneficiaries}
									typedBeneficiaries={contingentBeneficiaries}
									history={history}
									match={match}
									actions={actions}
								/>
							)}
							{this.props.beneficiaries.find(b => b.isUnderage === true) &&
							<div className="form-fieldset content-set">
								<div className="customer-dashboard-plan-info">
									<strong className="d-inline large">
										Trustee
									</strong>
								</div>
								<div className="row">
									<TextInput
										id="trusteeFirstName"
										labelText="First Name"
										name="firstName"
										value={this.props.trustee.firstName}
										onChange={this.onTrusteeChange}
										className="col-md-6"
										required={true}
									/>
									<TextInput
										id="trusteeLastName"
										labelText="Last Name"
										name="lastName"
										value={this.props.trustee.lastName}
										onChange={this.onTrusteeChange}
										className="col-md-6"
										required={true}
									/>
									<TextInput
										id="trusteeEmail"
										labelText="E-mail Address"
										name="email"
										value={this.props.trustee.email}
										onChange={this.onTrusteeChange}
										className="col-md-6"
										required={true}
									/>
								</div>
							</div>
							}
							<div className="text-md-right mt-4">
										<Button
											className="btn-outline-primary col-md-2 mr-3"
											onClick={this.cancelManagement}
										>
											Cancel
										</Button>
										<Button
											to={`/admin/customers/${this.props.match.params.customerId}/beneficiaries/new`}
											className="btn-outline-primary mr-3"
											disabled={this.isUpdateDisabled()}
										>
											<span className="align-middle mx-2">Add a beneficiary</span>
											<IconAdd />
										</Button>
										<Button className="btn-primary" disabled={this.isUpdateDisabled()} onClick={this.updateDisbursement}>
											Save and Update
										</Button>
							</div>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any, props: Props) {
	return {
		beneficiaries: state.policy.beneficiaries.pending,
		customerPolicy: state.policy.customerPolicy,
		trustee: state.policy.trustee
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(PolicyBeneficiariesDisbursementPage);
const adminRoles = [roles.Administrator, roles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerBeneficiariesDisbursementPage.tsx